angular.module('components.sessionTimer.SessionTimerController', [
])

/**
 * The SessionTimerController manages scope logic and user
 * interaction.
 *
 * @class EditorController
 * @constructor
 * @module components.sessionTimer.SessionTimerController
 */
.controller('SessionTimerController', [
  '$scope',
  '$rootScope',
  '$uibModal',
  '$timeout',
  '$state',
  'LoginService',
  function ($scope, $rootScope, $uibModal, $timeout, $state, LoginService) {
    'use strict';

    var lastApiCall;
    var countdownTimer;
    var modalTimer;
    var modalInstance;
    var timerThreshold = 600; // 600 = 10 minutes - 3590 = 59 min 50 seconds
    var tokenRefreshThreshold = 600; // 600 = 10 minutes
    var logoutThreshold = 0;

    $scope.modalOpen = false;
    $scope.seconds = 0;
    $scope.fMinutes = 0;
    $scope.fSeconds = 0;

    /**
     * Method logApiRequestTime logs the time of the most recent API Request
     *
     * @private
     */
    function logApiRequestTime() {
      lastApiCall = moment();
    }

    /**
     * Method checkForApiRequestTime checks for an api
     * request within configured threshold
     *
     * @private
     */
    function checkForApiRequestTime() {
      // var now = moment().add(10, 'm'); // for testing, adds 10 min
      var now = moment();
      var diff = moment.duration(now.diff(lastApiCall)).asSeconds();
      if (diff <= tokenRefreshThreshold) {
        $scope.refreshToken();
      } else {
        $scope.openModal();
      }
    }

    /**
     * Method getDurationFromToken get the difference in seconds
     * between now and the epiration of the token.
     *
     * @param {string} token - jwt encoded token
     * @private
     */
    function getDurationFromToken(token) {
      var timeToOpen;
      var parsedToken = jwt_decode(token);
      var diff = moment.duration(moment.unix(parsedToken.exp).diff(moment())).asSeconds();
      $scope.tokenExpiration = parsedToken.exp;

      stopTimers();

      timeToOpen = (diff - timerThreshold);
      modalTimer = $timeout(checkForApiRequestTime, timeToOpen * 1000);
    }

    /**
     * Method checkForToken checks to see if there is a user token.
     *
     * @private
     */
    function checkForToken() {
      var token;
      // check to see if we're in the authoring or delivery environment
      $scope.isAuthoring = LoginService.isAuthoring;

      $timeout(function () {
        token = LoginService.getToken();
        if (token !== null) {
          getDurationFromToken(token);
        } else {
          stopTimers();
        }
      });
    }

    /**
     * Method stopTimers stops all timers.
     *
     */
    function stopTimers() {
      $timeout.cancel(countdownTimer);
      $timeout.cancel(modalTimer);
    }

    /**
     * Method countSecondsToLogout decrements $scope.seconds by 1 every second.
     *
     * @private
     */
    function countSecondsToLogout() {
      if ($scope.seconds === logoutThreshold) {
        stopTimers();
        $scope.logout();
      } else {
        $scope.seconds -= 1;
        $scope.timeleft = moment($scope.seconds * 1000).format('mm:ss');
        countdownTimer = $timeout(countSecondsToLogout, 1000);
      }
    }

    /**
     * Method refreshToken refreshes their token and keeps them logged in.
     *
     */
    $scope.refreshToken = function () {
      LoginService.refreshToken(LoginService.getToken());
      stopTimers();
      if (modalInstance) {
        modalInstance.close();
      }
    };

    /**
     * Method logout logs to user out if they click the logout button
     *
     */
    $scope.logout = function () {
      stopTimers();
      modalInstance.close();
      $state.go('routes.logout');
    };

    /**
     * Method openModal opens a dialog allowing the user to
     * refresh their session or logout.
     *
     */
    $scope.openModal = function () {
      var diff;
      if (!$scope.modalOpen) {
        diff = moment.duration(moment.unix($scope.tokenExpiration).diff(moment())).asSeconds();
        $scope.seconds = Math.floor(diff);

        countdownTimer = $timeout(countSecondsToLogout, 1000);
        $scope.timeleft = moment($scope.seconds * 1000).format('mm:ss');


        modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'components/sessionTimer/sessionTimer.html',
          size: 'md',
          scope: $scope
        });

        modalInstance.opened.then(function () {
          $scope.modalOpen = true;
          return true;
        }).catch(function (err) {
          console.log(err);
        });

        modalInstance.result.then(function () {
          $scope.modalOpen = false;
          return true;
        }, function () {
          $scope.modalOpen = false;
          return true;
        }).catch(function (err) {
          console.log(err);
        });
      }
    };

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      // check to see if we're in the authoring or delivery environment
      $scope.isAuthoring = LoginService.isAuthoring;

      $rootScope.$on('userLoggedOut', stopTimers);
      $rootScope.$on('ApiRequestComplete', logApiRequestTime);
      $rootScope.$on('tokenSet', checkForToken);
    }

    initialize();
  }
]);
